import React from "react";

export default function TableViewPage() {
  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Gestione Tabella</h2>
      {/* Qui andrà il TableManager */}
    </div>
  );
}